import styles from "./SearchInput.module.css";
import { searchsvg } from "../../assets/svg/svgimages";

const SearchInput = ({ handleSearch, search }) => {
  const handleClear = () => {
    handleSearch({ target: { value: "" } });
  };

  return (
    <div className={styles.searchField}>
      <span className={styles.searchIcon} aria-hidden="true">
        {searchsvg}
      </span>
      <input
        className={styles.searchInput}
        type="text"
        placeholder="Search camera or lens"
        id="library-search"
        name="library_search"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck={false}
        enterKeyHint="search"
        aria-label="Search camera or lens"
        value={search}
        onChange={handleSearch}
      />
      {search && (
        <button
          type="button"
          className={styles.clearButton}
          onClick={handleClear}
          aria-label="Clear search"
        >
          <span aria-hidden="true">×</span>
        </button>
      )}
    </div>
  );
};

export default SearchInput;
